export default{
    simpleSave: ({commit, dispatch}, dataSave) => {
        let i = 0
        for(var data in dataSave){
            commit('SIMPLE_SAVE',[data, dataSave[data]])
            let returnData = dataSave[data]
            if(typeof returnData == 'object'){
                let dataString = returnData
                returnData = JSON.stringify({data : dataString, type : 'object'})
            }
            localStorage.setItem(`${data}`, returnData)
            i++
        }
    },
    saveObject: ({commit, dispatch}, dataSave) => {
        commit('SAVE_OBJECT',[dataSave[0], dataSave[1], dataSave[2]])
        let data = JSON.parse(localStorage.getItem(`${dataSave[0]}`))
        if(!data){
            data = {}
            data[dataSave[1]] = ''
        }
        data[dataSave[1]] = dataSave[2]
        localStorage.setItem(`${dataSave[0]}`, JSON.stringify(data))
    },
    pushMessage: ({commit, dispatch}, message) => {
        commit('PUSH_MESSAGE', message)
        let messages = JSON.parse(localStorage.getItem('messagesBot'))
        if(!messages){
            messages = []
        }
        messages.push(message)
        let newMessages = JSON.stringify(messages)
        localStorage.setItem('messagesBot', newMessages)
    },
    callSetFeedback({commit, dispatch}, objectItem){
        commit('SET_FEEDBACK_ITEM', objectItem)
    }
}